import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SyncAllMaterialsFromLinkedHeatpunkProjectMutation as _SyncAllMaterialsFromLinkedHeatpunkProjectMutation,
  SyncAllMaterialsFromLinkedHeatpunkProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SyncAllMaterialsFromLinkedHeatpunkProjectMutation = graphql(`
  mutation SyncAllMaterialsFromLinkedHeatpunkProject(
    $input: SyncAllMaterialsFromLinkedHeatpunkProjectInput!
  ) {
    syncAllMaterialsFromLinkedHeatpunkProject(input: $input)
  }
`);

const useSyncAllMaterialsFromLinkedHeatpunkProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _SyncAllMaterialsFromLinkedHeatpunkProjectMutation,
    unknown,
    SyncAllMaterialsFromLinkedHeatpunkProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: SyncAllMaterialsFromLinkedHeatpunkProjectInput) => {
      return gqlClient.request(
        SyncAllMaterialsFromLinkedHeatpunkProjectMutation,
        {
          input,
        }
      );
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSyncAllMaterialsFromLinkedHeatpunkProject;
